// extracted by mini-css-extract-plugin
export default {"root":"loading__root___DFB5b","overlay":"loading__overlay___h_34m","colorPrimary":"loading__colorPrimary___irm1R"};